<script>
	import { getContext, onDestroy } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../../library/scripts/styles'
	import { storeElementID, storeData } from '../../library/scripts/Store.svelte'
	import { get_initial_site_values } from '../builderUtils'
	import ColorSelector from '../ColorSelector.svelte'

	export let width

	const globals = getContext('globals')
	const fsXS = globals.fsXS
	const mainTool = globals.mainTool
	const mainToolHover = globals.mainToolHover

	let elementID
	let config

	let showSiteTool1 = false
	let showSiteTool2 = false

	//css selections
	let selectedBackground
	let selectedBgOpac
	let selectedCaColor
	let selectedCaHover

	//stative ID for getElementById in SelectValues
	const idColor1 = '1'
	const idColor2 = '2'
	const idColor3 = '3'

	const stoData = storeData.subscribe((value) => {
		if (value) {
			config = value
			selectedCaColor = value.caretColor
			selectedCaHover = value.caretHover
		}
	})

	const stoElementID = storeElementID.subscribe((value) => {
		elementID = value
	})

	//set the initial css values from config.json
	$: if (elementID === 'Site') {
		const values = get_initial_site_values(config)
		selectedBackground = values[0]
		selectedBgOpac = values[1]
	}

	const set_css_tag = (cssTag, cmd) => {
		if (cmd === 'bg') {
			config.body = cssTag
			document.getElementsByTagName('body')[0].style.backgroundColor = cssTag
		}

		if (cmd === 'cC') config.caretColor = cssTag
		if (cmd === 'cH') config.caretHover = cssTag
		storeData.set(config)
	}

	const set_bg_color = (e) => {
		set_css_tag(e.detail.color, 'bg')
	}

	const set_caret_color = (e) => {
		set_css_tag(e.detail.color, 'cC')
	}

	const set_caret_hover = (e) => {
		set_css_tag(e.detail.color, 'cH')
	}

	const open_tool = (t) => {
		if (t === 't1') {
			showSiteTool1 = showSiteTool1 === false ? true : false
			showSiteTool2 = false
		}
		if (t === 't2') {
			showSiteTool2 = showSiteTool2 === false ? true : false
			showSiteTool1 = false
		}
	}

	onDestroy(() => {
		stoElementID
		stoData
	})
</script>

<main use:styles={{ width }}>
	<div
		class="part_title mainTool"
		on:click={() => open_tool('t1')}
		on:keydown={() => open_tool('t1')}
		use:styles={{ mainTool, mainToolHover, fsXS }}
	>
		BODY
	</div>
	{#if showSiteTool1}
		<div transition:slide={{ duration: 500 }}>
			<div class="sub_title" use:styles={{ fsXS }}>Background</div>
			<ColorSelector
				on:setcolor={set_bg_color}
				on:setopacity={set_bg_color}
				on:settransparent={set_bg_color}
				transparent="1"
				ID={idColor1}
				selectedColor={selectedBackground}
				initialValue={selectedBgOpac}
			/>
		</div>
	{/if}

	<div
		class="part_title mainTool"
		on:click={() => open_tool('t2')}
		on:keydown={() => open_tool('t2')}
		use:styles={{ mainTool, mainToolHover, fsXS }}
	>
		SCROLL ICON
	</div>

	{#if showSiteTool2}
		<div transition:slide={{ duration: 500 }}>
			<div class="sub_title" use:styles={{ fsXS }}>Color</div>
			<ColorSelector
				on:setcolor={set_caret_color}
				ID={idColor2}
				selectedColor={selectedCaColor}
				showTranparency={false}
			/>

			<div class="sub_title" use:styles={{ fsXS }}>Hover</div>
			<ColorSelector
				on:setcolor={set_caret_hover}
				ID={idColor3}
				selectedColor={selectedCaHover}
				showTranparency={false}
			/>
		</div>
	{/if}
</main>

<style>
	main {
		width: var(--with);
		user-select: none;
	}

	.sub_title {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		background: hsl(0, 0%, 70%);
		color: black;
		font-size: var(--fsS);
		padding: 10px;
		border-bottom: 1px solid black;
	}

	.part_title {
		display: flex;
		width: 100%;
		justify-content: center;
		border-bottom: none;
		font-size: var(--fsXS);
		font-weight: bold;
		background-color: chocolate;
		padding: 10px;
		margin-top: 10px;
		cursor: pointer;
	}

	.sub_title {
		font-size: var(--fsXS);
		border-bottom: none;
		padding: 10px 0px 3px 10px;
	}

	.mainTool {
		background-color: var(--mainTool);
	}

	.mainTool:hover {
		background-color: var(--mainToolHover);
	}
</style>
